module.exports = __webpack_public_path__ + "static/media/hall.ef716678.png";